if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const ActiveProduct = $(this).closest(".active-product");
        const qtyInput = ActiveProduct.find('.quantity_buynow_wrap .product__quantity__input');
        const qtyInput_val = qtyInput.val();
        const quantity = qtyInput_val ? Number(qtyInput_val) || 1 : 1;

        const hidden_product_count = ActiveProduct.find(".hidden_product_input").length;
        //const random_no = generateBundleId();
        const random_no = (window.crypto && crypto.randomUUID)
          ? crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
          });

        if (ActiveProduct.length > 0) {
          const input_trikot = ActiveProduct.find('.properties_trikot');
          if (input_trikot.length) {
            input_trikot.val(random_no);
          }
        }
        else {
          const cardWrapper = $(this).closest('.product-card-wrapper');
          const input_trikot = cardWrapper.find('.properties_trikot');
          if (input_trikot.length) {
            input_trikot.val(random_no);
          }
        }

        let selected_products = [];
        //console.log("hidden_product",hidden_product_count);
        if (hidden_product_count > 0) {

          let product_form__error_message_wrapper = ActiveProduct.find(".product-form__error-message-wrapper");
          let product_form__error_message = ActiveProduct.find(".product-form__error-message");
          // Individuell: the custom name and the custom number are each OPTIONAL
          // once the individual route is chosen. Every combination is valid —
          // only a number, only a name, both, or neither — so there is no
          // "both required" error. Values are trimmed so a whitespace-only entry
          // counts as empty; this also cleanly removes the old workaround of
          // typing spaces into the name to slip past the previous validation.
          let individuell_no = (ActiveProduct.find(".individuell_fields input.individuell-nummer").val() || "").trim();
          let individuell_name = (ActiveProduct.find(".individuell_fields input.individuell-name").val() || "").trim();

          product_form__error_message_wrapper.attr("hidden", true);
          product_form__error_message.text("");

          // Spieler: the player's number comes from the variant custom field manufacturer_sku
          // (rendered into the selected option's data-nummer). It is split into per-digit ziffer
          // line items after the main loop. Block add-to-cart if a player is selected without a
          // valid numeric number.
          let spieler_selected = false;
          let spieler_number = "";
          ActiveProduct.find('.hidden_product_input[data-content="spieler"]').each(function () {
            const $sel = $(this).find(":selected");
            // value "0" is the "Spieler auswählen …" placeholder; a real player option has a data-variantid
            if ($sel.length && $sel.val() && $sel.val() !== "0" && $sel.data("variantid")) {
              spieler_selected = true;
              spieler_number = ($sel.attr("data-nummer") || "").trim();
            }
          });
          if (spieler_selected && !/^\d+$/.test(spieler_number)) {
            product_form__error_message_wrapper.removeAttr("hidden");
            product_form__error_message.text("Für diesen Spieler ist keine gültige Nummer hinterlegt.");
            return false;
          }

          // ===== Build the bundle line items: main FIRST, then addons (personalization → ziffer → badges) =====
          // Canonical scheme: main { _TRIKOT, Index, Delivery }; addons { _PARENT-TRIKOT, sort_order, Index, Delivery, FLOCK }.
          // No SKU property — the real variant SKU carries it. sort_order is 0-based across addons; Index (added later) is global.
          const addons = []; // each: { id, quantity, amount, flock }

          // ONE ziffer line item PER DIGIT — no quantity-merging:
          //   "1"  -> 1 line, "11" -> 2 separate lines, "13" -> 2 lines.
          // Each digit occurrence is pushed as its own qty-1 addon; the distinct
          // sort_order/Index assigned below keep same-digit lines from merging in
          // the cart. Each line carries the full number in FLOCK for production.
          // The per-digit variant is looked up from the individuell/nummer digit
          // checkboxes, so the number/ziffer product must be linked to the trikot
          // for any lines to be created (a spieler-only product with no number
          // product produces none). Shared by the Spieler number and custom number.
          const pushNumberDigitAddons = (numberStr) => {
            const digits = String(numberStr).split("");
            console.log("[trikot][cart] number:", numberStr, "→", digits.length, "digit line item(s):", digits);
            digits.forEach((digit, i) => {
              const $z = ActiveProduct.find('.hidden_product_input[data-content="individuell"] .data-option-individuell input[type="checkbox"][value="' + digit + '"]').first();
              const vid = $z.data("variantid");
              if (vid) {
                console.log("[trikot][cart]   digit #" + (i + 1) + ":", digit, "→ ziffer variant", vid, "| amount", $z.data("amount"));
                addons.push({ id: vid, quantity: 1, amount: $z.data("amount"), flock: "Nr. " + numberStr, type: "nummer" });
              } else {
                console.warn("[trikot][cart]   digit #" + (i + 1) + ":", digit, "→ NO ziffer checkbox [value=\"" + digit + "\"] — NOT added. This product has no number/ziffer variant linked.");
              }
            });
          };

          // Personalization (Spieler) + its number → one ziffer item per digit
          if (spieler_selected) {
            const $psel = ActiveProduct.find('.hidden_product_input[data-content="spieler"] select').find(":selected");
            if ($psel.data("variantid")) {
              addons.push({ id: $psel.data("variantid"), quantity: quantity, amount: $psel.data("amount"), flock: ($psel.attr("data-name") || "").trim(), type: "spieler" });
            }
            pushNumberDigitAddons(spieler_number);
          }

          // Personalization (Individuell name) + its number → one ziffer item per digit
          if (individuell_name) {
            const $n = ActiveProduct.find('.hidden_product_input[data-content="individuell"] .data-option-individuell-name input[type="checkbox"]').first();
            if ($n.data("variantid")) {
              addons.push({ id: $n.data("variantid"), quantity: 1, amount: $n.data("amount"), flock: individuell_name, type: "individuell" });
            }
          }
          // Custom number: same per-digit billing as the player number above.
          if (individuell_no) {
            pushNumberDigitAddons(individuell_no);
          }

          // Badges (each checked patch) — FLOCK = badge name (the checkbox value)
          ActiveProduct.find('.hidden_product_input input[name="Patches"]:checked').each(function () {
            const $b = $(this);
            if ($b.data("variantid")) {
              addons.push({ id: $b.data("variantid"), quantity: 1, amount: $b.data("amount"), flock: ($b.val() || "").trim(), type: "badge" });
            }
          });

          // Main jersey FIRST (carries _TRIKOT + _bundle_type/_jersey_type/_gender via its form inputs) + Delivery.
          const mainProps = {};
          const mainFormProps = new FormData(this.form);
          for (const [key, value] of mainFormProps.entries()) {
            const m = key.match(/^properties\[(.+)\]$/);
            if (!m) { continue; }
            if (value instanceof File) {
              if (value.size > 0) { mainProps[m[1]] = value; } // e.g. properties[_TrikotImage]
            } else if (typeof value === "string" && value.trim() !== "") {
              mainProps[m[1]] = value;
            }
          }
          mainProps.Delivery = "Lieferung";
          // post one jersey line with _components so the cart transform expands + prices it
          // attrs carry the exact original add-on line-item props so orders stay unchanged
          mainProps._components = JSON.stringify(addons.map(function (a, i) {
            var attrs = { "_PARENT-TRIKOT": random_no, sort_order: i, Delivery: "Lieferung", FLOCK: a.flock };
            if (typeof a.amount !== "undefined" && window.aico_percentage_discount && window.aico_percentage_discount != 0) {
              attrs._price_item_discount = applyAicoDiscount(a.amount);
            }
            return { v: String(a.id), t: a.type, f: a.flock, p: String(typeof a.amount === "undefined" ? "" : a.amount), attrs: attrs };
          }));

          // bundle price + badges total summary for the cart/drawer breakdown
          var _pName = "";
          var _pNumber = "";
          var _pBadges = [];
          var _hasSpieler = false;
          var _hasCustom = false;
          var _badgesTotal = 0;
          addons.forEach(function (a) {
            if (a.type === "spieler") { _pName = a.flock; _hasSpieler = true; }
            else if (a.type === "individuell") { _pName = a.flock; _hasCustom = true; }
            else if (a.type === "nummer") { _pNumber = a.flock; _hasCustom = true; }
            else if (a.type === "badge") {
              _pBadges.push(a.flock);
              var _bn = parseFloat(a.amount);
              if (!isNaN(_bn)) { _badgesTotal += _bn; }
            }
          });
          var _bundlePrice = _hasSpieler ? 25 : (_hasCustom ? 30 : 0);
          if (_pName) { mainProps._pName = _pName; }
          if (_pNumber) { mainProps._pNumber = _pNumber; }
          if (_pBadges.length) { mainProps._pBadge = _pBadges.join(", "); }
          if (_bundlePrice > 0) { mainProps._pBundlePrice = _bundlePrice.toFixed(2); }
          if (_badgesTotal > 0) { mainProps._pBadgesTotal = _badgesTotal.toFixed(2); }

          // resolve the variant from the checked size at submit time, not the (possibly stale)
          // hidden id, so add-to-cart submits the size shown after a reload; fall back to the id
          var mainVariantId = this.form.querySelector('[name="id"]') ? this.form.querySelector('[name="id"]').value : null;
          try {
            var $vsPicker = ActiveProduct.find('variant-selects').first();
            if (!$vsPicker.length) { $vsPicker = $('variant-selects').first(); }
            var _vjson = $vsPicker.find('script[data-product-variants]').first().text();
            if (_vjson) {
              var _variants = JSON.parse(_vjson);
              var _chosen = [];
              $vsPicker.find('fieldset').each(function () {
                var _r = $(this).find('input[type="radio"]:checked').first();
                var _s = $(this).find('select').first();
                if (_r.length) { _chosen.push(_r.val()); }
                else if (_s.length) { _chosen.push(_s.val()); }
              });
              if (_chosen.length) {
                var _key = _chosen.join('~~');
                for (var _vi = 0; _vi < _variants.length; _vi++) {
                  if ((_variants[_vi].options || []).join('~~') === _key) { mainVariantId = String(_variants[_vi].id); break; }
                }
              }
            }
          } catch (e) { /* keep the fallback id */ }
          console.log("[trikot][cart] add-to-cart resolved variant id:", mainVariantId);

          selected_products.push({ id: mainVariantId, quantity: quantity, properties: mainProps });

        } // hidden_product close

        //console.log("selected_products", JSON.stringify(selected_products));
        console.log("[trikot][cart] bundle line items being added:", selected_products.map(function (p) {
          return { id: p.id, quantity: p.quantity, FLOCK: p.properties && p.properties.FLOCK, bundle: p.properties && (p.properties._bundle_type || p.properties["_PARENT-TRIKOT"]) };
        }));

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // unique, always-increasing Index: base it on the MAX existing Index in the cart (+1),
        // not the line count, so deleting an item and re-adding never reuses a number
        if (selected_products.length > 0) {
          let cartBase = 0;
          try {
            const cartData = await fetch(`${routes.cart_url}.js`).then((r) => r.json());
            (cartData.items || []).forEach(function (it) {
              var idx = parseInt(it.properties && it.properties.Index, 10);
              if (!isNaN(idx) && idx > cartBase) { cartBase = idx; }
            });
          } catch (e) {
            cartBase = 0;
          }
          selected_products.forEach(function (p, i) {
            p.properties.Index = cartBase + i + 1;
          });
          // Shopify's /cart/add.js bulk add inserts the items[] array into the cart in REVERSE order.
          // Assign Index in the intended order above, then submit reversed so the cart ends up showing
          // the main jersey first, then addons by ascending sort_order (each keeps its own Index/sort_order).
          selected_products.reverse();
        }

        // ✅ Append `selected_products` to FormData
        var formData = "";
        if (selected_products.length > 0) {

          formData = new FormData();

          // ✅ Append `selected_products` first
          selected_products.forEach((product, index) => {
            formData.append(`items[${index}][id]`, product.id);
            formData.append(`items[${index}][quantity]`, product.quantity);

            // Append properties if they exist
            if (product.properties) {
              Object.keys(product.properties).forEach((key) => {
                const val = product.properties[key];
                if (val instanceof File) {
                  if (val.size > 0) {
                    formData.append(`items[${index}][properties][${key}]`, val, val.name);
                  }
                } else {
                  formData.append(`items[${index}][properties][${key}]`, val);
                }
              });
            }
          });

          // (the main jersey is already selected_products[0], so no separate append needed)
        }
        else {

          const originalFormData = new FormData(this.form);
          formData = new FormData();

          for (const [key, value] of originalFormData.entries()) {
            if (key.startsWith("properties[")) {
              if (value instanceof File) {
                if (value.size > 0) {
                  formData.append(key, value, value.name);
                }
              } else if (typeof value === "string" && value.trim() !== "") {
                formData.append(key, value.trim());
              }
            } else {
              // Keep all other fields (like id, quantity)
              formData.append(key, value);
            }
          }
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
